import TopNavbar from './TopNavbar.vue';
import DashboardContent from './Content.vue';
import Loader from '../Shared/Loader.vue';

export default {

    methods: {
        toggleSidebar () {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        }
    },

    components: {
        TopNavbar,
        DashboardContent,
        Loader
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/MainView.js